import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api, money } from "../lib/api";
import { useAuth } from "../lib/auth";
import { PageTitle } from "../components/site/PageTitle";
import { TicketWallet } from "../components/site/TicketWallet";

export default function AccountPage() {
  const { user, logout } = useAuth();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    if (user) api.myOrders().then(setOrders).catch(() => setOrders([]));
  }, [user]);

  if (user === false) return <Navigate to="/login" replace />;
  if (!user) return null;

  return (
    <>
      <PageTitle kicker={user.email} title="My account" />
      <TicketWallet />
      <section className="px-5 lg:px-12 max-w-3xl space-y-4">
        <h2 className="font-gothic text-4xl mb-2">My orders</h2>
        {orders && orders.length === 0 && <p className="text-slate-400" data-testid="orders-empty">No orders yet.</p>}
        {(orders || []).map((o) => (
          <div key={o.session_id} className="card-surface rounded-xl p-5" data-testid={`order-${o.session_id}`}>
            <div className="flex justify-between text-sm text-slate-400 mb-3">
              <span>{new Date(o.created_at).toLocaleString()}</span><span className="text-lime font-mono-ui">{money(o.amount)}</span>
            </div>
            {o.items.map((it, i) => <p key={i} className="text-sm">{it.quantity} × {it.name}</p>)}
          </div>
        ))}
        <button onClick={logout} data-testid="logout-button" className="btn-line rounded-full px-6 py-3 font-cond uppercase tracking-widest mt-6">Log out</button>
      </section>
    </>
  );
}
